import React from 'react';
import Dialog from '#lib/components/dialog.jsx';
import { cn } from '#lib/helpers/class.js';
import { newIdPrefix } from '#helpers/helpers.js';

export function DocumentObject(props) {
    const { src, ...rest } = props;
    return <object className="w-full h-full object-contain" data={src} {...rest} />;
}

export function DocumentModal(props) {
    const { document, isOpen, onClose } = props;
    let src = document?.src;

    if (document?.id.startsWith(newIdPrefix)) src = `${MEDIA_URL}/${src}`;

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col bottom-0 top-4 h-[95%] max-h-[90%] w-full max-w-[1400px] space-y-4">
                <div className="pr-4">
                    <Dialog.CloseButton />
                    <b>{_t.components.modal.documentPreview()}</b>
                </div>
                <div className="relative w-full h-full overflow-auto border border-neutral-200 rounded-lg">
                    {document ? (
                        <DocumentObject src={`${src}#toolbar=0&navpanes=0&&statusbar=0&messages=0&scrollbar=0`} />
                    ) : null}
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
